<template>
    <div class="banner">
        <div class="carousel">
            <el-carousel :interval="5000" height="360px">
                <el-carousel-item v-for="(item, index) in homeA" :key="index">
                    <ads-item 
                        class="carousel-item"
                        :data="item"
                        font-size="16px"
                        offset="18px"
                        @update="getSedToken" @power="publicPowerShow"  @tryon="tryonDialogShow"
                        v-czc="['首页', '点击列表' , '大幻灯' ,index+1 , `home-list-carousel`]"
                    ></ads-item>
                </el-carousel-item>
            </el-carousel>
        </div>
         <!-- 会员体验特权到期弹窗 -->
        <tryon-dialog ref="tryon" :ispower="isPower"></tryon-dialog>
        <publicPower ></publicPower>
    </div>
</template>

<script>
import AdsItem from '@components/sys/ads-item';
import tryonDialog from '@components/sys/my-header/components/tryon-dialog'
import publicPower from '@components/sys/my-header/components/public-power'
import {mapState} from 'vuex';
export default {
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        AdsItem,
        tryonDialog,
        publicPower
    },
    data(){
        return{
            isPower:false
        }
    },
    computed: {
        ...mapState({
            advMap: state => {
                return state.ads.map;
            },
        }),
        homeA() {
            return this.data[this.advMap.homeA] || [];
        },

    },
    methods:{
        getSedToken(){
            this.$refs.tryon.checkUserState()
        },
        tryonDialogShow(){
            this.isPower = true
            this.$refs.tryon.openFreeVipInfo()
        },
        publicPowerShow(){
            this.$refs.power.openDialog()
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';
   
    .banner{
        width: 100%;
        overflow: hidden;
        .carousel{
            width: 100%;
            height: 365px;
            background-color: $primaryColor1;

            .carousel-item {
                width: 100%;
                height: 100%;
            }
        }

        .ads{
            float: right;
            width: 350px;
            height: 100%;
            overflow: hidden;

            .ads-item {
                width: 100%;
                height: 175px;
                float: left;
                cursor: pointer;
                background-color: $primaryColor1;

                & + .ads-item{
                    margin-top: 10px;
                }
            }
        }
    }
</style>

<style>
    .swiperHome{
        width: 100%;
        margin: 0 !important;
    }
     .swiperHome .banner{
        width: 100%;
     }
</style>